.d2{aspect-ratio:1/1;}